/* eslint-disable import/prefer-default-export */
import { AxiosPromise } from 'axios';
import { Notification } from '../store/notificationSlice';
import api, { getPaginatedCountFromResponse } from './api';

export function getCurrentNotifications(pageIndex: number, pageSize: number, viewed: any) {
  return new Promise<{ data: any; count: number | null }>((resolve, reject) => {
    try {
      api.get('/notifications/current', {
        params: {
          pageIndex,
          pageSize,
          viewed,
        }
      })
        .then((response: any) => {
          resolve({ data: response.data, count: getPaginatedCountFromResponse(response) });
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function getAllNotifications(pageIndex: number, pageSize: number, viewed: any) {
  return new Promise<{ data: any; count: number | null }>((resolve, reject) => {
    try {
      api.get('/notifications/all', {
        params: {
          pageIndex,
          pageSize,
          viewed,
        }
      })
        .then((response: any) => {
          resolve({ data: response.data, count: getPaginatedCountFromResponse(response) });
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function updateNotification(id: number, body: Partial<Notification>) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api.patch(`/notifications/${id}`, body)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
export function updateNotificationAsRead() {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api.post(`/notifications/mark-all-read`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
